import React, { useState, Fragment } from 'react';
import {
  H2,
  P,
  Icon,
  Modal,
  ModalHeader,
  ModalBody,
  Grid,
  Header,
  FlexRow,
  BaseCol
} from '@contently/toolkit';
import TableWrapper from './table_wrapper';

const StoryLevelWrapper = () => {
  const [modal, setModal] = useState(false);

  return (
    <Fragment>
      <Modal isOpen={modal} onClose={() => setModal(false)}>
        <ModalHeader>
          <H2>Story Content Value</H2>
        </ModalHeader>
        <ModalBody>
          <P>
            This page tracks the Content Value of individual stories. To learn more about the
            metrics that appear on this page, visit{' '}
            <a href="https://help.contently.com/en/articles/4273934-understanding-and-improving-your-content-value-dashboard">
              this article
            </a>{' '}
            in Contently&apos;s help center.
          </P>
        </ModalBody>
      </Modal>
      <Grid>
        <FlexRow>
          <BaseCol>
            <Header>
              <H2>
                Story Content Value
                <Icon type="question-circle" onClick={() => setModal(true)} />
              </H2>
            </Header>
          </BaseCol>
        </FlexRow>
        <FlexRow>
          <BaseCol>
            <TableWrapper tableInfo={[]} header="Traffic Value by Content Pillar" />
          </BaseCol>
        </FlexRow>
      </Grid>
    </Fragment>
  );
};

export default StoryLevelWrapper;



// WEBPACK FOOTER //
// ./app/javascript/app/components/story_level_value/story_level_wrapper.jsx